import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { FrontbackConfig } from '../models/frontback-config';

@Injectable({
  providedIn: 'root'
})
export class FrontbackConfigService {
  // TODO: dynamic origin
  private url = 'https://thesatellite.satellitedeskworks.com/api/v1/frontback/configs';

  constructor(private http: HttpClient) { }

  query(): Observable<FrontbackConfig[]> {
    return this.http.get<FrontbackConfig[]>(this.url);
  }

}
